import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgIcon } from '../../enums/svg-icon';

@Component({
  selector: 'app-svg-icon',
  imports: [],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  public readonly icon = input.required<SvgIcon>();
  public readonly fill = input<string>('inherit');

  protected readonly SvgIcon = SvgIcon;
}
